module.exports = __webpack_public_path__ + "media/images/manager-login-282b3708.jpg";